/**
 * Component: Page Header image loader
 */

var dnDepartments = dnDepartments || {};

dnDepartments.pageHeaderImage = dnDepartments.pageHeaderImage || function () {
    this.init = function() {
        loadPageHeaderImage();
    }

    this.loadPageHeaderImage = function() {
        var pageHeader = $('#js-page-header-image');

        if (pageHeader.length !== 0) {
            var width = pageHeader.outerWidth();
            var height = pageHeader.outerHeight();

            var src = pageHeader.data('src');
            var focalPoint = pageHeader.data('focalpoint');
            var mode = pageHeader.data('mode');
            var quality = pageHeader.data('quality');

            src = src + '?width=' + width + '&height=' + height + "&mode=" + mode + '&center=' + focalPoint + '&quality=' + quality;
            pageHeader.css('background-image', 'url(' + src + ')');
        }
    }

    return {
        init: init
    };
}();